import React from 'react';

export interface FjSideNavItemProps {
  title?: string;
  id?: string;
  icon?: React.ReactElement;
  titleFontSizeOverride?: string;
  'data-testid'?: string;
}

class FjSideNavItem extends React.Component<FjSideNavItemProps> {
  // Depends on FjSideNav to render
  render(): React.ReactNode {
    return null;
  }
}

export default FjSideNavItem;
